import { PortalPage, Spinner, ErrorNote } from "@/components/PortalPage";
import { BkTabs, EntitySwitcher, useBkEntities } from "@/components/bookkeeping/BkShell";

// Shared frame for every Bookkeeping screen: entity switcher + tabs on top.
export const BkPage = ({ title, testId, children }) => {
  const bk = useBkEntities();
  return (
    <PortalPage eyebrow="BOOKKEEPING" title={title} back="/dashboard" testId={testId} width="max-w-6xl">
      {bk.error && <ErrorNote>{bk.error}</ErrorNote>}
      {!bk.entities ? <Spinner /> : (
        <>
          <EntitySwitcher entities={bk.entities} entityId={bk.entityId} onChange={bk.setEntityId} />
          <BkTabs />
          {bk.entity && children(bk)}
        </>
      )}
    </PortalPage>
  );
};

export const fmtMoney = (n) => (n == null ? "–" : `${n < 0 ? "-" : ""}$${Math.abs(n).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`);
export const fmtTime = (s) => (s ? new Date(s).toLocaleString() : "Never");
export const Card = ({ title, children, testId, right }) => (
  <section className="rounded-xl border border-[#333] bg-[#141414] p-5" data-testid={testId}>
    <div className="mb-3 flex items-center justify-between gap-3">
      <p className="text-[11px] font-bold tracking-[3px] text-[#4CCC06]">{title}</p>{right}
    </div>
    {children}
  </section>
);
export const SmallBtn = ({ children, primary, ...p }) => (
  <button {...p} className={`rounded-lg px-3 py-1.5 text-xs font-extrabold transition-opacity disabled:cursor-not-allowed disabled:opacity-40 ${primary ? "bg-[#4CCC06] text-black disabled:bg-[#2A2A2A] disabled:text-neutral-500" : "border border-[#333] text-white hover:border-[#4CCC06]"}`}>{children}</button>
);
